import React, {memo} from 'react';

import {emojiToUrl} from '../../../../srcCommon/helpers/emoji/emojiHelpers';
import {EmojiInheritableProps} from '../../../services/emojis/emojiTypes';

/*
 * Component.
 */

export const InlineEmoji = memo<EmojiInheritableProps>((props) => {
  const {emoji, skinTone} = props;
  const emojiUrl = emojiToUrl(emoji, skinTone);

  return (
    <img
      alt={emoji.shortcode}
      src={emojiUrl}
      style={{
        verticalAlign: 'text-bottom',
        height: props.size,
        width: props.size,
      }}
    />
  );
});
